import './home.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React, { useEffect } from 'react';
import { Layout, Typography, Button, Carousel, Row, Col, Card, Space } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const galleryImages = ['/content/images/c1.jpg', '/content/images/c2.jpg', '/content/images/c3.jpg'];

const PetGroomingLanding: React.FC = () => {
  useEffect(() => {
    // Header ve Footer gizle
    const header = document.getElementById('app-header');
    const footer = document.getElementById('app-footer');

    if (header) header.style.display = 'none';
    if (footer) footer.style.display = 'none';

    // Component unmount olursa tekrar göster
    return () => {
      if (header) header.style.display = 'block';
      if (footer) footer.style.display = 'block';
    };
  }, []);

  return (
    <Layout style={{ background: '#fff' }}>
      <Content>
        {/* ================= HERO SECTION 2-COLUMN ================= */}
        <section style={{ padding: '100px 24px', background: '#fff' }}>
          <Row gutter={[48, 24]} align="middle" justify="center">
            {/* ================= LEFT COLUMN (TEXT) ================= */}
            <Col xs={24} md={12}>
              <Title level={1} style={{ color: '#0F2A44', lineHeight: 1.2 }}>
                Professional Pet Grooming in London
              </Title>
              <Paragraph style={{ color: '#0F2A44', fontSize: 18, lineHeight: 1.8, marginTop: 24 }}>
                Premium grooming services for dogs and cats — gentle care, beautiful results, and a stress-free experience for your pet.
              </Paragraph>

              <Space size="large" style={{ marginTop: 32 }}>
                <Button type="primary" size="large" href="mailto:info@happypaws.co.uk?subject=Pet%20Grooming%20Appointment">
                  📧 Book Appointment
                </Button>
                <Button size="large" href="tel:+447XXXXXXX">
                  📞 Call Us
                </Button>
              </Space>
            </Col>

            {/* ================= RIGHT COLUMN (IMAGE) ================= */}
            <Col xs={24} md={12} style={{ textAlign: 'center' }}>
              <img
                src="/content/images/hero.jpg" // Premium fotoğraf
                alt="Happy pet grooming"
                style={{
                  width: '100%',
                  maxWidth: 500, // Maksimum genişlik
                  height: 'auto',
                  maxHeight: 400,
                  borderRadius: 16,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                  objectFit: 'cover', // Section yüksekliğine uyum sağlar
                }}
              />
            </Col>
          </Row>
        </section>

        {/* ================= PORTFOLIO / GALLERY ================= */}
        <section style={{ padding: '80px 24px', background: '#fafafa' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: 40 }}>
            Our Grooming Work
          </Title>
          (portfolyoyu kayan resimler olarak ekleyeceğiz üzerine tıklatıgınızda portfolyo sayfasında before after resimlerini topluca
          görünecek sayfaya yonlenecek)
          <Row justify="center">
            <Col xs={24} md={16} lg={12}>
              <Carousel autoplay dotPosition="bottom">
                {galleryImages.map((img, index) => (
                  <div key={index}>
                    <img
                      src={img}
                      alt={'Pet grooming portfolio_' + index}
                      style={{
                        width: '100%',
                        height: 420,
                        objectFit: 'cover',
                        borderRadius: 12,
                      }}
                    />
                  </div>
                ))}
              </Carousel>
            </Col>
          </Row>
        </section>

        {/* ================= ABOUT / TRUST ================= */}
        <section style={{ padding: '80px 24px' }}>
          <Row justify="center">
            <Col xs={24} md={18} lg={14}>
              <Card bordered={false} style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#0F2A44', marginBottom: 24 }}>
                  Why Pet Owners Trust Us
                </Title>

                <Paragraph style={{ color: '#0F2A44', fontSize: 16, lineHeight: 1.8 }}>
                  With over 8 years of professional grooming experience, we provide breed-specific grooming tailored to your pet’s needs.
                  Fully insured, highly trained, and passionate about animal wellbeing.
                </Paragraph>

                <Row gutter={[24, 24]} justify="center" style={{ marginTop: 32 }}>
                  <Col xs={24} md={8}>
                    <Title level={5} style={{ color: '#0F2A44' }}>
                      🐾 Experienced Groomers
                    </Title>
                    <Paragraph style={{ color: '#0F2A44' }}>Certified and caring professionals.</Paragraph>
                  </Col>
                  <Col xs={24} md={8}>
                    <Title level={5} style={{ color: '#0F2A44' }}>
                      ⭐ 5-Star Reviews
                    </Title>
                    <Paragraph style={{ color: '#0F2A44' }}>Loved by local pet owners.</Paragraph>
                  </Col>
                  <Col xs={24} md={8}>
                    <Title level={5} style={{ color: '#0F2A44' }}>
                      📍 Local & Trusted
                    </Title>
                    <Paragraph style={{ color: '#0F2A44' }}>Serving London and surrounding areas.</Paragraph>
                  </Col>
                </Row>

                {/* ================= CONTACT INFO ================= */}
                <Row justify="center" style={{ marginTop: 40, gap: '16px' }}>
                  <Col>
                    <Button type="link" href="tel:+447XXXXXXX" style={{ fontSize: 16, color: '#0F2A44' }}>
                      📞 +44 7XXX XXX XXX
                    </Button>
                  </Col>
                  <Col>
                    <Button type="link" href="mailto:info@happypaws.co.uk" style={{ fontSize: 16, color: '#0F2A44' }}>
                      📧 info@happypaws.co.uk
                    </Button>
                  </Col>
                </Row>

                {/* ================= SOCIAL BUTTONS ================= */}
                <Row justify="center" gutter={16} style={{ marginTop: 32 }}>
                  <Col>
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<i className="fab fa-facebook-f" />}
                      href="https://facebook.com"
                      target="_blank"
                      style={{ backgroundColor: '#1877F2', border: 'none' }}
                    />
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<i className="fab fa-instagram" />}
                      href="https://instagram.com"
                      target="_blank"
                      style={{ backgroundColor: '#E4405F', border: 'none' }}
                    />
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<i className="fab fa-twitter" />}
                      href="https://twitter.com"
                      target="_blank"
                      style={{ backgroundColor: '#1DA1F2', border: 'none' }}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </section>

        {/* ================= LOCATION / MAP ================= */}
        <section style={{ padding: '80px 24px', background: '#111' }}>
          <Row justify="center">
            <Col xs={24} md={20} lg={16}>
              <Title level={2} style={{ color: '#fff', textAlign: 'center', marginBottom: 32 }}>
                Visit Our Grooming Studio
              </Title>

              <Paragraph style={{ color: '#ccc', textAlign: 'center', marginBottom: 40 }}>
                Conveniently located in the heart of London, easily accessible for local pet owners.
              </Paragraph>

              <div
                style={{
                  width: '100%',
                  height: 420,
                  borderRadius: 16,
                  overflow: 'hidden',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                }}
              >
                <iframe
                  title="Pet Grooming Location"
                  src="https://www.google.com/maps?q=London&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Col>
          </Row>
        </section>
      </Content>
    </Layout>
  );
};

export default PetGroomingLanding;
